module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"addLabtests":"მონაცემის დამატება","search":"ძიება","present":"ფიქსირდება","absent":"არ ფიქსირდება","very_low":"ძალიან დაბალი","low":"დაბალი","normal":"ნორმა","high":"მაღალი","very_high":"ძალიან მაღალი"},"en":{"addLabtests":"Add Data","search":"Search","present":"Present","absent":"Absent","very_low":"Very Low","low":"Low","normal":"Normal","high":"High","very_high":"Very High"}}')
  delete Component.options._Ctor
}
